import React from 'react';
import './WeatherIcon.css';
import weatherIconMap from '../../common/weatherIcons';
import logComponent from '../../common/logComponent';

export default function WeatherIcon({ icon }) {
  if (logComponent('WeatherIcon')) { console.debug('WeatherIcon rendered'); }

  const getIcon = () => {
    if (logComponent('WeatherIcon')) { console.debug('WeatherIcon getIcon'); }
    return weatherIconMap.get(icon);
  }

  return (
    <div className="Weather-Icon">{getIcon()}</div>
  );
}